export default __webpack_public_path__ + "static/media/CrownRaising.2f44711c.jpg";